const UserFacingError = require('./UserFacingError');

/**
 * Turns an Error object into a string that can be shown to the end user.
 *
 * @constructor
 *
 * @param {LangService} langService
 */
const ErrorPresenter = function (
    langService
) {
    this.langService = langService;
};

ErrorPresenter.prototype = {
    /**
     * @param {Error|string} error
     *
     * @return {string}
     */
    getText(error) {
        if (error instanceof UserFacingError) {
            return this.langService.getText(error.getLangKey());
        }

        // Returns something like "Something has gone wrong.";
        let genericPrefix = this.langService.getText('ERROR.GENERIC');

        let message;
        if (error instanceof Error) {
            message = error.message;
        } else {
            // Assume it's a string.
            message = error;
        }

        return genericPrefix + (message ? ' ' + message : '');
    },
};

module.exports = ErrorPresenter;
